import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

export const ADD_LABELS_TO_ARTICLE =
	'state.actions.add-labels-to-article.ADD_LABELS_TO_ARTICLE' as const;

export type AddLabelsToArticlePayload = {
	articleId: string;
	spaceKey: string;
	labels: {
		name: string;
	}[];
	analyticsEvent: UIAnalyticsEvent;
};

export type AddLabelsToArticleAction = {
	type: typeof ADD_LABELS_TO_ARTICLE;
	payload: AddLabelsToArticlePayload;
};

export const addLabelsToArticle = (
	payload: AddLabelsToArticlePayload,
): AddLabelsToArticleAction => ({
	payload,
	type: ADD_LABELS_TO_ARTICLE,
});
